import { useViewportSize } from '@mantine/hooks'
import useMobile from 'src/hooks/useMobile'
import DualLangHeader from '../components/DualLangHeader'
import { GeneralHeaderText, ColoredSpan, SmallText, Highlight, sampleMacbook, segment1, segment2, segment3 } from '../styles'
import { BuiltForYouSectionWrapper, LaptopContainer, Laptop, Chibis } from '../styles/BuiltForYouSection.styles'

const BuiltForYouSection = () => {
  const { width } = useViewportSize()
  const isMobile = useMobile()

  const shouldBreak = width > 814
  const showLaptop = width > 714

  return (
    <BuiltForYouSectionWrapper>
      <DualLangHeader otherLang='どんなレベルにもピッタリ！' style={{ padding: '24px 0' }}>
        <GeneralHeaderText>
          Built for <ColoredSpan color='white'>You!</ColoredSpan>
        </GeneralHeaderText>
      </DualLangHeader>
      <SmallText isMobile={isMobile} style={{ textAlign: 'center', padding: '0 36px' }}>
        Created for students of {' '}
        <Highlight>every level and background</Highlight>,{' '}
        From Zero! is perfect for
        {shouldBreak ? <br/> : ' '}
        <ColoredSpan color='white'>absolute beginners as well as current students</ColoredSpan> of Japanese!
      </SmallText>
      <LaptopContainer>
        {showLaptop && <Laptop src={sampleMacbook} />}
        <Chibis src={segment1} position='top' />
        <Chibis src={segment2} position='bottom' />
        <Chibis src={segment3} position='right' />
      </LaptopContainer>
    </BuiltForYouSectionWrapper>
  )
}

export default BuiltForYouSection
